import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

export default function MCheck(props) {
  return (
    <FormControlLabel
      label={props.label}
      control={
        <Checkbox
          checked={props.checked}
          onChange={(e) => props.onChange(e.target.checked)}
          color="secondary"
          disabled={props.disabled ? props.disabled : false}
        />
      }
    />
  );
}
